export default __webpack_public_path__ + "static/media/profile.ac29bcc3.png";